import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { API_PATH } from './config';

function NoticiaId() {
  const { id } = useParams(); // <-- esto reemplaza this.props.match.params
  const [noticia, setNoticia] = useState(null);

  useEffect(() => {
    fetch(`${API_PATH}news/${id}`)
      .then(r => r.json())
      .then(data => setNoticia(data));
  }, [id]);

  if (!noticia) return <div className="preloader" >
                    <div className="div-transform">
                        <div className="loader">
                            <div className="face">
                                <div className="circle"></div>
                            </div>
                            <div className="face">
                <div className="circle"></div>
          </div>
        </div>
      </div>
    </div>;

    function formatFecha(fechaWP) {
        return new Date(fechaWP).toLocaleDateString("pt-BR", {
            day: "numeric",
            month: "long",
            year: "numeric",
        });
    }

  return (
    <>
     <div className="container-fluid bg-black" >
            <br/><br/>
            <h1 align="center" className="tituloPrincipal"><b>Noticias</b></h1>
        </div>
        <div className='container'>
            <h1 className="content-news-h1" dangerouslySetInnerHTML={this.Sanitize(noticia.title.rendered)} />
            <br/>
            {/* <span className="fecha-n">{formatFecha(noticia.date)}</ span> <br/> <br/> */}
            <div
                dangerouslySetInnerHTML={ this.Sanitize(noticia.content.rendered)}
                className="text-justify font-18 content-news-content pjus"
            />
            <br/>
        </div>
    </>
  );
}

export default NoticiaId;
